/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
//
// THIS IS A GENERATED FILE
// DO NOT MODIFY IT! YOUR CHANGES WILL BE LOST
export enum BookingQuestionRuleConditionType {
  REQUIRED_BY_VALUE = 0,
  OPTIONS_FILTERED_BY_VALUE = 1,
  SHOW_IF_VALUE = 2,
  SHOW_IF_HAS_VALUE = 3,
  VALUE_LINKED_TO = 4
}
